export const courseProgressConsts = {
  INIT_GROUP_COURSE_PROGRESS: "INIT_GROUP_COURSE_PROGRESS",
  INIT_GROUP_COURSE_PROGRESS_SUCCESS: "INIT_GROUP_COURSE_PROGRESS_SUCCESS",
  INIT_GROUP_COURSE_PROGRESS_FAILURE: "INIT_GROUP_COURSE_PROGRESS_FAILURE",

  GET_STUDENT_COURSE_PROGRESS: "GET_STUDENT_COURSE_PROGRESS",
  GET_STUDENT_COURSE_PROGRESS_SUCCESS: "GET_STUDENT_COURSE_PROGRESS_SUCCESS",
  GET_STUDENT_COURSE_PROGRESS_FAILURE: "GET_STUDENT_COURSE_PROGRESS_FAILURE",

  GET_STUDENTS_COURSE_ITEM_BANKS: "GET_STUDENTS_COURSE_ITEM_BANKS",
  GET_STUDENTS_COURSE_ITEM_BANKS_SUCCESS:
    "GET_STUDENTS_COURSE_ITEM_BANKS_SUCCESS",
  GET_STUDENTS_COURSE_ITEM_BANKS_FAILURE:
    "GET_STUDENTS_COURSE_ITEM_BANKS_FAILURE",

  GET_GROUP_COURSE_PROGRESS: "GET_GROUP_COURSE_PROGRESS",
  GET_GROUP_COURSE_PROGRESS_SUCCESS: "GET_GROUP_COURSE_PROGRESS_SUCCESS",
  GET_GROUP_COURSE_PROGRESS_FAILURE: "GET_GROUP_COURSE_PROGRESS_FAILURE",

  UPDATE_GROUP_COURSE_PROGRESS: "UPDATE_GROUP_COURSE_PROGRESS",
  UPDATE_GROUP_COURSE_PROGRESS_SUCCESS: "UPDATE_GROUP_COURSE_PROGRESS_SUCCESS",
  UPDATE_GROUP_COURSE_PROGRESS_FAILURE: "UPDATE_GROUP_COURSE_PROGRESS_FAILURE",

  ADD_STUDENT_ACTIVITY: "ADD_STUDENT_ACTIVITY",
  ADD_STUDENT_ACTIVITY_SUCCESS: "ADD_STUDENT_ACTIVITY_SUCCESS",
  ADD_STUDENT_ACTIVITY_FAILURE: "ADD_STUDENT_ACTIVITY_FAILURE",

  CHANGE_LESSON_STATUS: "CHANGE_LESSON_STATUS",
  CHANGE_LESSON_STATUS_SUCCESS: "CHANGE_LESSON_STATUS_SUCCESS",
  CHANGE_LESSON_STATUS_FAILURE: "CHANGE_LESSON_STATUS_FAILURE",

  UPDATE_ITEM_ANSWER: "UPDATE_ITEM_ANSWER",
  UPDATE_ITEM_ANSWER_SUCCESS: "UPDATE_ITEM_ANSWER_SUCCESS",
  UPDATE_ITEM_ANSWER_FAILURE: "UPDATE_ITEM_ANSWER_FAILURE",

  SUBMIT_EXIT_TICKET: "SUBMIT_EXIT_TICKET",
  SUBMIT_EXIT_TICKET_SUCCESS: "SUBMIT_EXIT_TICKET_SUCCESS",
  SUBMIT_EXIT_TICKET_FAILURE: "SUBMIT_EXIT_TICKET_FAILURE",

  INIT_EXIT_TICKET: "INIT_EXIT_TICKET",
  INIT_EXIT_TICKET_SUCCESS: "INIT_EXIT_TICKET_SUCCESS",
  INIT_EXIT_TICKET_FAILURE: "INIT_EXIT_TICKET_FAILURE",

  SET_DEFAULT_USER_CP: "SET_DEFAULT_USER_CP",
  UPDATE_COURSE_PROGRESS: "UPDATE_COURSE_PROGRESS",
  UPDATE_COURSE_PROGRESS_SUCCESS: "UPDATE_COURSE_PROGRESS_SUCCESS",
  UPDATE_COURSE_PROGRESS_FAILURE: "UPDATE_COURSE_PROGRESS_FAILURE",

  UPDATE_STUDENT_NODE_DATA: "UPDATE_STUDENT_NODE_DATA",
  UPDATE_STUDENT_NODE_DATA_SUCCESS: "UPDATE_STUDENT_NODE_DATA_SUCCESS",
  UPDATE_STUDENT_NODE_DATA_FAILURE: "UPDATE_STUDENT_NODE_DATA_FAILURE"
}
